export default __webpack_public_path__ + "static/media/link.32675702.svg";